require('angular').module('oly.common')
    .directive('olySlideup', require('./slideup.directive').slideupStickyDirectiveDefinition);




// WEBPACK FOOTER //
// ./src/olycommon/slideup/index.js